// import {
//   Box,
//   Tab,
//   Tabs,
//   IconButton,
//   Container,
//   Paper,
//   Avatar,
//   Typography,
//   Chip,
//   Tooltip,
//   useTheme,
//   useMediaQuery,
//   createTheme,
//   ThemeProvider,
// } from "@mui/material";
// import { ArrowBack, Person } from "@mui/icons-material";
// import React, { useEffect, useState } from "react";
// import OpenOrderTable from "../OpenOrderTable";
// import { useParams } from "react-router-dom";
// import UserProfile from "../UserProfile";
// import SearchHistory from "../SearchHistory";
// import PPOrders from "../PPOrders";
// import ActivityLogs from "../ActivityLogs";


// const medstownTheme = createTheme({
//   palette: {
//     primary: {
//       main: "#1d5244",
//       light: "#4a7c59",
//       dark: "#0f2920",
//       contrastText: "#ffffff",
//     },
//     secondary: {
//       main: "#2e7d32",
//       light: "#60ad5e",
//       dark: "#1b5e20",
//     },
//     background: {
//       default: "#f8f9fa",
//       paper: "#ffffff",
//     },
//   },
//   typography: {
//     fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
//     h5: {
//       fontWeight: 600,
//       fontSize: "1.5rem",
//     },
//     h6: {
//       fontWeight: 600,
//       fontSize: "1.25rem",
//     },
//     body1: {
//       fontWeight: 500,
//       fontSize: "1rem",
//     },
//     body2: {
//       fontWeight: 400,
//       fontSize: "0.875rem",
//       color: "#6b7280",
//     },
//   },
//   components: {
//     MuiCard: {
//       styleOverrides: {
//         root: {
//           borderRadius: 12,
//           boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
//           border: "1px solid #e5e7eb",
//         },
//       },
//     },
//     MuiPaper: {
//       styleOverrides: {
//         root: {
//           borderRadius: 12,
//           boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
//         },
//       },
//     },
//   },
// })
// export default function UserActivity() {
//   const { id } = useParams();
//   console.log(id,"id")
//   const [tabIndex, setTabIndex] = useState(0);
//   const [userData, setUserData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const handleChange = (event, newValue) => {
//     setTabIndex(newValue);
//   };

//   useEffect(() => {
//     const fetchUserProfile = async () => {
//       setLoading(true);
//       setError(null);

//       try {
//         const baseUrl = "https://api.medstown.com";
//         const response = await fetch(
//           `${baseUrl}/api/admin-controls/user/profile/${id}`,
//           {
//             method: "GET",
//             headers: {
//               "Content-Type": "application/json",
//             },
//           }
//         );

//         if (!response.ok) {
//           throw new Error(`HTTP error! status: ${response.status}`);
//         }

//         const result = await response.json();
// console.log(result,'result')
//         if (result.success && result.data) {
//           setUserData(result.data);
//         } else {
//           throw new Error(result.message || "Failed to fetch user data");
//         }
//       } catch (err) {
//         console.error("Error fetching user profile:", err);
//         setError(err.message || "An error occurred while fetching user data");
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (id) {
//       fetchUserProfile();
//     }
//   }, [id]);

//   const handleBackClick = () => {
//     // Add your back navigation logic here
//     // For example: navigate(-1) or router.back()
//     window.history.back();
//   };

//   return (
//     <ThemeProvider theme={medstownTheme}>
//     <Box sx={{ width: "100%", mt: 5 }}>
//       <Container maxWidth="lg">
//         {/* Header */}
//         <Paper sx={{ p: 3, mb: 3, bgcolor: "primary.main", color: "white" }}>
//           <Box
//             display="flex"
//             alignItems="center"
//             justifyContent="space-between"
//           >
//             <Box display="flex" alignItems="center">
//               <Avatar
//                 sx={{
//                   bgcolor: "primary.dark",
//                   mr: 2,
//                   width: 60,
//                   height: 60,
//                 }}
//               >
//                 <Person sx={{ fontSize: 30 }} />
//               </Avatar>
//               <Box>
                
//                 <Typography
//                   variant={isMobile ? "h6" : "h5"}
//                   sx={{ fontWeight: 700 }}
//                 >
//                   {userData?.fullName || "User Profile"}
//                 </Typography>
//                 <Typography variant="body1">ID: {userData?.userId}</Typography>
//               </Box>
//             </Box>
//             <Box display="flex" alignItems="center" gap={2}>
//               <Chip
//                 label={userData?.userType || "Customer"}
//                 sx={{
//                   bgcolor: "rgba(255,255,255,0.2)",
//                   color: "white",
//                   fontWeight: 600,
//                 }}
//               />
              
//             </Box>
//           </Box>
//         </Paper>
//       </Container>
//       {/* Back Button */}
//       {/* <Box sx={{ mb: 3 }}>
//         <IconButton
//           onClick={handleBackClick}
//           sx={{
//             background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
//             backdropFilter: "blur(10px)",
//             borderRadius: "12px",
//             padding: "12px",
//             boxShadow: "0 8px 24px rgba(0, 0, 0, 0.08)",
//             border: "1px solid rgba(255, 255, 255, 0.2)",
//             color: "#64748b",
//             transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//             "&:hover": {
//               transform: "translateY(-2px) scale(1.05)",
//               boxShadow: "0 12px 32px rgba(0, 0, 0, 0.12)",
//               background: "linear-gradient(135deg, #ffffff 0%, #f1f5f9 100%)",
//               color: "#3b82f6",
//             },
//             "&:active": {
//               transform: "translateY(0) scale(0.98)",
//             }
//           }}
//         >
//           <ArrowBack sx={{ fontSize: "20px" }} />
//         </IconButton>
//       </Box> */}

//       {/* Tabs */}
//       <Box>
//         <Tabs
//           value={tabIndex}
//           onChange={handleChange}
//           variant="fullWidth"
//           TabIndicatorProps={{ style: { display: "none" } }}
//           sx={{
//             backgroundColor: "rgba(255, 255, 255, 0.8)",
//             backdropFilter: "blur(10px)",
//             borderRadius: "16px",
//             padding: "8px",
//             boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)",
//             border: "1px solid rgba(255, 255, 255, 0.2)",
//             "& .MuiTabs-flexContainer": {
//               gap: "8px",
//             },
//           }}
//         >
//           <Tab
//             label="User Profile"
//             sx={{
//               textTransform: "none",
//               fontWeight: 600,
//               fontSize: "15px",
//               borderRadius: "12px",
//               padding: "16px 24px",
//               background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
//               color: "#64748b",
//               border: "1px solid rgba(226, 232, 240, 0.6)",
//               transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//               position: "relative",
//               overflow: "hidden",
//               "&:hover": {
//                 transform: "translateY(-2px)",
//                 boxShadow: "0 12px 24px rgba(0, 0, 0, 0.1)",
//                 background: "linear-gradient(135deg, #ffffff 0%, #f1f5f9 100%)",
//               },
//               "&.Mui-selected": {
//                 background: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
//                 color: "#ffffff",
//                 boxShadow: "0 12px 32px rgba(59, 130, 246, 0.4)",
//                 transform: "translateY(-3px)",
//                 border: "1px solid rgba(59, 130, 246, 0.3)",
//                 "&::after": {
//                   content: '""',
//                   position: "absolute",
//                   bottom: "6px",
//                   left: "50%",
//                   transform: "translateX(-50%)",
//                   width: "24px",
//                   height: "3px",
//                   backgroundColor: "#ffffff",
//                   borderRadius: "2px",
//                   opacity: 0.8,
//                 },
//               },
//             }}
//           />
//           <Tab
//             label="Open Orders"
//             sx={{
//               textTransform: "none",
//               fontWeight: 600,
//               fontSize: "15px",
//               borderRadius: "12px",
//               padding: "16px 24px",
//               background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
//               color: "#64748b",
//               border: "1px solid rgba(226, 232, 240, 0.6)",
//               transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//               position: "relative",
//               overflow: "hidden",
//               "&:hover": {
//                 transform: "translateY(-2px)",
//                 boxShadow: "0 12px 24px rgba(0, 0, 0, 0.1)",
//                 background: "linear-gradient(135deg, #ffffff 0%, #f1f5f9 100%)",
//               },
//               "&.Mui-selected": {
//                 background: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
//                 color: "#ffffff",
//                 boxShadow: "0 12px 32px rgba(59, 130, 246, 0.4)",
//                 transform: "translateY(-3px)",
//                 border: "1px solid rgba(59, 130, 246, 0.3)",
//                 "&::after": {
//                   content: '""',
//                   position: "absolute",
//                   bottom: "6px",
//                   left: "50%",
//                   transform: "translateX(-50%)",
//                   width: "24px",
//                   height: "3px",
//                   backgroundColor: "#ffffff",
//                   borderRadius: "2px",
//                   opacity: 0.8,
//                 },
//               },
//             }}
//           />
//           <Tab
//             label="PP Orders"
//             sx={{
//               textTransform: "none",
//               fontWeight: 600,
//               fontSize: "15px",
//               borderRadius: "12px",
//               padding: "16px 24px",
//               background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
//               color: "#64748b",
//               border: "1px solid rgba(226, 232, 240, 0.6)",
//               transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//               position: "relative",
//               overflow: "hidden",
//               "&:hover": {
//                 transform: "translateY(-2px)",
//                 boxShadow: "0 12px 24px rgba(0, 0, 0, 0.1)",
//                 background: "linear-gradient(135deg, #ffffff 0%, #f1f5f9 100%)",
//               },
//               "&.Mui-selected": {
//                 background: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
//                 color: "#ffffff",
//                 boxShadow: "0 12px 32px rgba(59, 130, 246, 0.4)",
//                 transform: "translateY(-3px)",
//                 border: "1px solid rgba(59, 130, 246, 0.3)",
//                 "&::after": {
//                   content: '""',
//                   position: "absolute",
//                   bottom: "6px",
//                   left: "50%",
//                   transform: "translateX(-50%)",
//                   width: "24px",
//                   height: "3px",
//                   backgroundColor: "#ffffff",
//                   borderRadius: "2px",
//                   opacity: 0.8,
//                 },
//               },
//             }}
//           />
//           <Tab
//             label="Search History"
//             sx={{
//               textTransform: "none",
//               fontWeight: 600,
//               fontSize: "15px",
//               borderRadius: "12px",
//               padding: "16px 24px",
//               background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
//               color: "#64748b",
//               border: "1px solid rgba(226, 232, 240, 0.6)",
//               transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//               position: "relative",
//               overflow: "hidden",
//               "&:hover": {
//                 transform: "translateY(-2px)",
//                 boxShadow: "0 12px 24px rgba(0, 0, 0, 0.1)",
//                 background: "linear-gradient(135deg, #ffffff 0%, #f1f5f9 100%)",
//               },
//               "&.Mui-selected": {
//                 background: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
//                 color: "#ffffff",
//                 boxShadow: "0 12px 32px rgba(59, 130, 246, 0.4)",
//                 transform: "translateY(-3px)",
//                 border: "1px solid rgba(59, 130, 246, 0.3)",
//                 "&::after": {
//                   content: '""',
//                   position: "absolute",
//                   bottom: "6px",
//                   left: "50%",
//                   transform: "translateX(-50%)",
//                   width: "24px",
//                   height: "3px",
//                   backgroundColor: "#ffffff",
//                   borderRadius: "2px",
//                   opacity: 0.8,
//                 },
//               },
//             }}
//           />
//           <Tab
//             label="Activity Logs"
//             sx={{
//               textTransform: "none",
//               fontWeight: 600,
//               fontSize: "15px",
//               borderRadius: "12px",
//               padding: "16px 24px",
//               background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
//               color: "#64748b",
//               border: "1px solid rgba(226, 232, 240, 0.6)",
//               transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//               position: "relative",
//               overflow: "hidden",
//               "&:hover": {
//                 transform: "translateY(-2px)",
//                 boxShadow: "0 12px 24px rgba(0, 0, 0, 0.1)",
//                 background: "linear-gradient(135deg, #ffffff 0%, #f1f5f9 100%)",
//               },
//               "&.Mui-selected": {
//                 background: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
//                 color: "#ffffff",
//                 boxShadow: "0 12px 32px rgba(59, 130, 246, 0.4)",
//                 transform: "translateY(-3px)",
//                 border: "1px solid rgba(59, 130, 246, 0.3)",
//                 "&::after": {
//                   content: '""',
//                   position: "absolute",
//                   bottom: "6px",
//                   left: "50%",
//                   transform: "translateX(-50%)",
//                   width: "24px",
//                   height: "3px",
//                   backgroundColor: "#ffffff",
//                   borderRadius: "2px",
//                   opacity: 0.8,
//                 },
//               },
//             }}
//           />
//         </Tabs>
//       </Box>

//       {/* Content Area */}
//       <Box
//         // sx={{
//         //   p: 4,
//         //   mt: 3,
//         //   background: "linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)",
//         //   borderRadius: "20px",
//         //   boxShadow: "0 20px 60px rgba(0, 0, 0, 0.08)",
//         //   border: "1px solid rgba(226, 232, 240, 0.3)",
//         //   position: "relative",
//         //   overflow: "hidden",
//         //   "&::before": {
//         //     content: '""',
//         //     position: "absolute",
//         //     top: 0,
//         //     left: 0,
//         //     right: 0,
//         //     height: "4px",
//         //     background: "linear-gradient(90deg, #3b82f6, #8b5cf6, #06b6d4)",
//         //     borderRadius: "20px 20px 0 0",
//         //   },
//         // }}
//       >
//         <Box
//           sx={{
//             transition: "all 0.4s ease-in-out",
//             opacity: 1,
//             transform: "translateY(0)",
//           }}
//         >
//           {/* const [error, setError] = useState(null); */}
//           {tabIndex === 0 && (
//             <UserProfile
//               id={id}
//               loading={loading}
//               userData={userData}
//               setUserData={setUserData}
//               setLoading={setLoading}
//               error={error}
//               setError={setError}
//             />
//             // "hello"
//           )}
//           {tabIndex === 1 && 
//           <OpenOrderTable userId={id} />
//           // "hello"
//           }
//           {tabIndex === 2 && <PPOrders userId={id} />}
//           {tabIndex === 3 && <SearchHistory userId={id} />}
//           {tabIndex === 4 && <ActivityLogs/>}
//         </Box>
//       </Box>
//     </Box>
//     </ThemeProvider>
//   );
// }



import {
  Box,
  Tab,
  Tabs,
  IconButton,
  Container,
  Paper,
  Avatar,
  Typography,
  Chip,
  Tooltip,
  useTheme,
  useMediaQuery,
  createTheme,
  ThemeProvider,
  Fade,
  Slide,
  Card,
  CardContent,
  Skeleton,
  Alert,
} from "@mui/material";
import { 
  ArrowBack, 
  Person, 
  ShoppingCart, 
  Search, 
  Timeline,
  AccountCircle,
  Assignment,
  Verified,
  Phone,
  Email,
  LocationOn
} from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import OpenOrderTable from "../OpenOrderTable";
import { useParams } from "react-router-dom";
import UserProfile from "../UserProfile";
import SearchHistory from "../SearchHistory";
import PPOrders from "../PPOrders";
import ActivityLogs from "../ActivityLogs";

const medstownTheme = createTheme({
  palette: {
    primary: {
      main: "#1e40af",
      light: "#3b82f6",
      dark: "#1e3a8a",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#059669",
      light: "#10b981",
      dark: "#047857",
    },
    background: {
      default: "#f8fafc",
      paper: "#ffffff",
    },
    grey: {
      50: "#f9fafb",
      100: "#f3f4f6",
      200: "#e5e7eb",
      300: "#d1d5db",
      400: "#9ca3af",
      500: "#6b7280",
      600: "#4b5563",
      700: "#374151",
      800: "#1f2937",
      900: "#111827",
    },
  },
  typography: {
    fontFamily: '"Inter", "Segoe UI", "Roboto", "Helvetica", sans-serif',
    h4: {
      fontWeight: 700,
      fontSize: "2.125rem",
      lineHeight: 1.2,
    },
    h5: {
      fontWeight: 600,
      fontSize: "1.5rem",
      lineHeight: 1.3,
    },
    h6: {
      fontWeight: 600,
      fontSize: "1.25rem",
      lineHeight: 1.4,
    },
    body1: {
      fontWeight: 500,
      fontSize: "1rem",
      lineHeight: 1.5,
    },
    body2: {
      fontWeight: 400,
      fontSize: "0.875rem",
      color: "#6b7280",
      lineHeight: 1.5,
    },
    caption: {
      fontWeight: 500,
      fontSize: "0.75rem",
      color: "#9ca3af",
    },
  },
  shape: {
    borderRadius: 16,
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
          border: "1px solid rgba(226, 232, 240, 0.8)",
          background: "linear-gradient(145deg, #ffffff 0%, #fafbff 100%)",
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          textTransform: "none",
          fontWeight: 600,
          padding: "12px 24px",
        },
      },
    },
  },
});

const tabIcons = [
  <AccountCircle />,
  <ShoppingCart />,
  <Assignment />,
  <Search />,
  <Timeline />,
];

const tabLabels = [
  "Profile",
  "Orders",
  "PP Orders", 
  "Search History",
  "Activity"
];

export default function UserActivity() {
  const { id } = useParams();
  const [tabIndex, setTabIndex] = useState(0);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isTablet = useMediaQuery(theme.breakpoints.down("lg"));

  const handleChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  useEffect(() => {
    const fetchUserProfile = async () => {
      setLoading(true);
      setError(null);

      try {
        const baseUrl = "https://api.medstown.com";
        const response = await fetch(
          `${baseUrl}/api/admin-controls/user/profile/${id}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        
        if (result.success && result.data) {
          setUserData(result.data);
        } else {
          throw new Error(result.message || "Failed to fetch user data");
        }
      } catch (err) {
        console.error("Error fetching user profile:", err);
        setError(err.message || "An error occurred while fetching user data");
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchUserProfile();
    }
  }, [id]);

  const handleBackClick = () => {
    window.history.back();
  };

  const getUserStatusColor = (userType) => {
    switch (userType?.toLowerCase()) {
      case 'premium':
        return { bg: '#fef3c7', color: '#d97706', icon: '👑' };
      case 'verified':
        return { bg: '#d1fae5', color: '#059669', icon: '✓' };
      case 'customer':
        return { bg: '#e0e7ff', color: '#3730a3', icon: '👤' };
      default:
        return { bg: '#f3f4f6', color: '#6b7280', icon: '👤' };
    }
  };

  const statusInfo = getUserStatusColor(userData?.userType);

  return (
    <ThemeProvider theme={medstownTheme}>
      <Box 
        sx={{ 
          minHeight: "100vh",
          // background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          position: "relative",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "radial-gradient(circle at 30% 20%, rgba(120, 119, 198, 0.3) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(255, 255, 255, 0.1) 0%, transparent 50%)",
            pointerEvents: "none",
          }
        }}
      >
        <Container maxWidth="xl" sx={{ position: "relative", zIndex: 1 }}>
          <Box sx={{ pt: { xs: 2, md: 4 }, pb: 4 }}>
            {/* Back Button */}
            {/* <Fade in timeout={600}>
              <Box sx={{ mb: 3 }}>
                <Tooltip title="Go Back" arrow>
                  <IconButton
                    onClick={handleBackClick}
                    sx={{
                      background: "rgba(255, 255, 255, 0.15)",
                      backdropFilter: "blur(20px)",
                      borderRadius: "16px",
                      padding: "14px",
                      border: "1px solid rgba(255, 255, 255, 0.2)",
                      color: "white",
                      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                      "&:hover": {
                        transform: "translateY(-2px) scale(1.05)",
                        background: "rgba(255, 255, 255, 0.25)",
                        boxShadow: "0 12px 32px rgba(0, 0, 0, 0.15)",
                      },
                      "&:active": {
                        transform: "translateY(0) scale(0.98)",
                      }
                    }}
                  >
                    <ArrowBack sx={{ fontSize: "24px" }} />
                  </IconButton>
                </Tooltip>
              </Box>
            </Fade> */}

            {/* User Header Card */}
            <Slide direction="down" in timeout={800}>
              <Card 
                sx={{ 
                  mb: 4,
                  background: "rgba(255, 255, 255, 0.95)",
                  backdropFilter: "blur(20px)",
                  border: "1px solid rgba(255, 255, 255, 0.3)",
                  overflow: "visible",
                  position: "relative",
                  // "&::before": {
                  //   content: '""',
                  //   position: "absolute",
                  //   top: 0,
                  //   left: 0,
                  //   right: 0,
                  //   height: "6px",
                  //   background: "linear-gradient(90deg, #3b82f6, #8b5cf6, #06b6d4, #10b981)",
                  //   borderRadius: "20px 20px 0 0",
                  // }
                }}
              >
                <CardContent sx={{ p: { xs: 3, md: 4 } }}>
                  {loading ? (
                    <Box display="flex" alignItems="center" gap={3}>
                      <Skeleton variant="circular" width={80} height={80} />
                      <Box flex={1}>
                        <Skeleton variant="text" width="60%" height={40} />
                        <Skeleton variant="text" width="40%" height={24} />
                        <Skeleton variant="rectangular" width={120} height={32} sx={{ mt: 1, borderRadius: 2 }} />
                      </Box>
                    </Box>
                  ) : error ? (
                    <Alert severity="error" sx={{ borderRadius: 3 }}>
                      {error}
                    </Alert>
                  ) : (
                    <Box 
                      display="flex" 
                      alignItems="center" 
                      justifyContent="space-between"
                      flexDirection={{ xs: "column", md: "row" }}
                      gap={{ xs: 3, md: 0 }}
                    >
                      <Box display="flex" alignItems="center" gap={3}>
                        <Box position="relative">
                          <Avatar
                            sx={{
                              width: { xs: 70, md: 80 },
                              height: { xs: 70, md: 80 },
                              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                              fontSize: { xs: 28, md: 32 },
                              border: "4px solid rgba(255, 255, 255, 0.3)",
                              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.15)",
                            }}
                          >
                            {userData?.profileImage ? (
                              <img 
                                src={userData.profileImage} 
                                alt="Profile" 
                                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                              />
                            ) : (
                              <Person sx={{ fontSize: "inherit" }} />
                            )}
                          </Avatar>
                          {userData?.isVerified && (
                            <Verified 
                              sx={{ 
                                position: "absolute",
                                bottom: -2,
                                right: -2,
                                color: "#059669",
                                bgcolor: "white",
                                borderRadius: "50%",
                                fontSize: 24,
                              }} 
                            />
                          )}
                        </Box>
                        
                        <Box>
                          <Typography
                            variant={isMobile ? "h6" : "h5"}
                            sx={{ 
                              fontWeight: 700,
                              background: "linear-gradient(135deg, #1e40af 0%, #7c3aed 100%)",
                              backgroundClip: "text",
                              WebkitBackgroundClip: "text",
                              WebkitTextFillColor: "transparent",
                              mb: 0.5,
                            }}
                          >
                            {userData?.fullName || "User Profile"}
                          </Typography>
                          
                          <Typography 
                            variant="body2" 
                            sx={{ 
                              color: "text.secondary",
                              mb: 1,
                              fontFamily: "monospace",
                              fontWeight: 600,
                            }}
                          >
                            ID: {userData?.userId || id}
                          </Typography>

                          <Box display="flex" gap={1} flexWrap="wrap">
                            <Chip
                              icon={<span style={{ fontSize: "14px" }}>{statusInfo.icon}</span>}
                              label={userData?.userType || "Customer"}
                              size="small"
                              sx={{
                                bgcolor: statusInfo.bg,
                                color: statusInfo.color,
                                fontWeight: 600,
                                border: `1px solid ${statusInfo.color}20`,
                                "& .MuiChip-icon": {
                                  color: statusInfo.color,
                                }
                              }}
                            />
                            
                            {userData?.joinDate && (
                              <Chip
                                label={`Joined ${new Date(userData.joinDate).getFullYear()}`}
                                size="small"
                                variant="outlined"
                                sx={{
                                  borderColor: "grey.300",
                                  color: "text.secondary",
                                  fontWeight: 500,
                                }}
                              />
                            )}
                          </Box>
                        </Box>
                      </Box>

                      {/* Quick Info Cards - Hidden on mobile, shown as summary */}
                      {!isMobile && userData && (
                        <Box display="flex" gap={2}>
                          {userData.phone && (
                            <Card sx={{ minWidth: 120, background: "rgba(59, 130, 246, 0.05)" }}>
                              <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
                                <Box display="flex" alignItems="center" gap={1} mb={1}>
                                  <Phone sx={{ fontSize: 16, color: "primary.main" }} />
                                  <Typography variant="caption" fontWeight={600}>
                                    Phone
                                  </Typography>
                                </Box>
                                <Typography variant="body2" fontWeight={600}>
                                  {userData.phone}
                                </Typography>
                              </CardContent>
                            </Card>
                          )}
                          
                          {userData.email && (
                            <Card sx={{ minWidth: 140, background: "rgba(16, 185, 129, 0.05)" }}>
                              <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
                                <Box display="flex" alignItems="center" gap={1} mb={1}>
                                  <Email sx={{ fontSize: 16, color: "secondary.main" }} />
                                  <Typography variant="caption" fontWeight={600}>
                                    Email
                                  </Typography>
                                </Box>
                                <Typography 
                                  variant="body2" 
                                  fontWeight={600}
                                  sx={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {userData.email}
                                </Typography>
                              </CardContent>
                            </Card>
                          )}
                        </Box>
                      )}
                    </Box>
                  )}
                </CardContent>
              </Card>
            </Slide>

            {/* Navigation Tabs */}
            <Slide direction="up" in timeout={1000}>
              <Card 
                sx={{ 
                  mb: 4,
                  background: "rgba(255, 255, 255, 0.95)",
                  backdropFilter: "blur(20px)",
                  border: "1px solid rgba(255, 255, 255, 0.3)",
                  overflow: "hidden",
                }}
              >
                <Tabs
                  value={tabIndex}
                  onChange={handleChange}
                  variant={isMobile ? "scrollable" : "fullWidth"}
                  scrollButtons={isMobile ? "auto" : false}
                  TabIndicatorProps={{ style: { display: "none" } }}
                  sx={{
                    p: 1,
                    "& .MuiTabs-flexContainer": {
                      gap: 1,
                    },
                    "& .MuiTabs-scroller": {
                      "& .MuiTabs-indicator": {
                        display: "none",
                      },
                    },
                  }}
                >
                  {tabLabels.map((label, index) => (
                    <Tab
                      key={index}
                      icon={tabIcons[index]}
                      iconPosition="start"
                      label={isMobile ? "" : label}
                      sx={{
                        textTransform: "none",
                        fontWeight: 600,
                        fontSize: "14px",
                        borderRadius: "14px",
                        minHeight: { xs: 56, md: 64 },
                        minWidth: { xs: 64, md: "auto" },
                        px: { xs: 1, md: 3 },
                        background: "transparent",
                        color: "text.secondary",
                        border: "2px solid transparent",
                        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                        position: "relative",
                        overflow: "hidden",
                        "&::before": {
                          content: '""',
                          position: "absolute",
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          background: "linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(139, 92, 246, 0.1) 100%)",
                          opacity: 0,
                          transition: "opacity 0.3s ease",
                        },
                        "&:hover": {
                          transform: "translateY(-2px)",
                          background: "rgba(59, 130, 246, 0.05)",
                          border: "2px solid rgba(59, 130, 246, 0.2)",
                          "&::before": {
                            opacity: 1,
                          },
                        },
                        "&.Mui-selected": {
                          background: "linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)",
                          color: "#ffffff",
                          transform: "translateY(-3px)",
                          boxShadow: "0 12px 32px rgba(59, 130, 246, 0.4)",
                          border: "2px solid rgba(255, 255, 255, 0.3)",
                          "&::before": {
                            opacity: 0,
                          },
                        },
                        "& .MuiTab-iconWrapper": {
                          mb: isMobile ? 0 : 0.5,
                          mr: isMobile ? 0 : 1,
                        },
                      }}
                    />
                  ))}
                </Tabs>
              </Card>
            </Slide>

            {/* Content Area */}
            <Fade in timeout={1200}>
              <Card
                sx={{
                  background: "rgba(255, 255, 255, 0.95)",
                  backdropFilter: "blur(20px)",
                  border: "1px solid rgba(255, 255, 255, 0.3)",
                  minHeight: "500px",
                  position: "relative",
                  overflow: "hidden",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    height: "1px",
                    background: "linear-gradient(90deg, transparent 0%, rgba(59, 130, 246, 0.5) 50%, transparent 100%)",
                  }
                }}
              >
                <CardContent sx={{ p: { xs: 2, md: 4 } }}>
                  <Box
                    sx={{
                      transition: "all 0.4s ease-in-out",
                      opacity: 1,
                      transform: "translateY(0)",
                    }}
                  >
                    {tabIndex === 0 && (
                      <Fade in key="profile" timeout={500}>
                        <Box>
                          <UserProfile
                            id={id}
                            loading={loading}
                            userData={userData}
                            setUserData={setUserData}
                            setLoading={setLoading}
                            error={error}
                            setError={setError}
                          />
                        </Box>
                      </Fade>
                    )}
                    
                    {tabIndex === 1 && (
                      <Fade in key="orders" timeout={500}>
                        <Box>
                          <Box mb={3}>
                            <Typography variant="h6" sx={{ fontWeight: 700, color: "text.primary", mb: 1 }}>
                              Open Orders
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              View and manage all active orders for this user
                            </Typography>
                          </Box>
                          <OpenOrderTable userId={id} />
                        </Box>
                      </Fade>
                    )}
                    
                    {tabIndex === 2 && (
                      <Fade in key="pp-orders" timeout={500}>
                        <Box>
                          <Box mb={3}>
                            <Typography variant="h6" sx={{ fontWeight: 700, color: "text.primary", mb: 1 }}>
                              PP Orders
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              Prescription and pharmaceutical order history
                            </Typography>
                          </Box>
                          <PPOrders userId={id} />
                        </Box>
                      </Fade>
                    )}
                    
                    {tabIndex === 3 && (
                      <Fade in key="search" timeout={500}>
                        <Box>
                          <Box mb={3}>
                            <Typography variant="h6" sx={{ fontWeight: 700, color: "text.primary", mb: 1 }}>
                              Search History
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              Track user search patterns and preferences
                            </Typography>
                          </Box>
                          <SearchHistory userId={id} />
                        </Box>
                      </Fade>
                    )}
                    
                    {tabIndex === 4 && (
                      <Fade in key="activity" timeout={500}>
                        <Box>
                          <Box mb={3}>
                            <Typography variant="h6" sx={{ fontWeight: 700, color: "text.primary", mb: 1 }}>
                              Activity Logs
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              Comprehensive user activity timeline and logs
                            </Typography>
                          </Box>
                          <ActivityLogs />
                        </Box>
                      </Fade>
                    )}
                  </Box>
                </CardContent>
              </Card>
            </Fade>

            {/* Mobile Quick Actions - Only visible on mobile */}
            {isMobile && userData && (
              <Slide direction="up" in timeout={1400}>
                <Card 
                  sx={{ 
                    mt: 3,
                    background: "rgba(255, 255, 255, 0.9)",
                    backdropFilter: "blur(15px)",
                  }}
                >
                  <CardContent sx={{ p: 2 }}>
                    <Typography variant="subtitle2" fontWeight={600} mb={2} color="text.primary">
                      Quick Info
                    </Typography>
                    <Box display="flex" justifyContent="space-between" gap={2}>
                      {userData.phone && (
                        <Box flex={1} textAlign="center">
                          <Phone sx={{ fontSize: 20, color: "primary.main", mb: 0.5 }} />
                          <Typography variant="caption" display="block" fontWeight={600}>
                            Phone
                          </Typography>
                          <Typography variant="body2" sx={{ fontSize: "12px" }}>
                            {userData.phone}
                          </Typography>
                        </Box>
                      )}
                      
                      {userData.email && (
                        <Box flex={1} textAlign="center">
                          <Email sx={{ fontSize: 20, color: "secondary.main", mb: 0.5 }} />
                          <Typography variant="caption" display="block" fontWeight={600}>
                            Email
                          </Typography>
                          <Typography 
                            variant="body2" 
                            sx={{ 
                              fontSize: "12px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {userData.email}
                          </Typography>
                        </Box>
                      )}
                      
                      {userData.location && (
                        <Box flex={1} textAlign="center">
                          <LocationOn sx={{ fontSize: 20, color: "warning.main", mb: 0.5 }} />
                          <Typography variant="caption" display="block" fontWeight={600}>
                            Location
                          </Typography>
                          <Typography variant="body2" sx={{ fontSize: "12px" }}>
                            {userData.location}
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  </CardContent>
                </Card>
              </Slide>
            )}
          </Box>
        </Container>
      </Box>
    </ThemeProvider>
  );
}